import { useEffect } from "react";
import "./about.styles.css";

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the window
  }, []);

  return (
    <div className="about-container">
      <h1 className="about-title">About</h1>
      <p className="about-description">
        Welcome to our online store! We are a small business dedicated to
        providing you with delivery services. We are here to enable local
        grocery stores to extend their reach beyond physical boundaries while
        helping customers maintain their connection to the local businesses they
        trust and value. Right now we are offering delivery from Mannan
        supermarket located in Ozone Park.
      </p>
      <p className="about-description">
        We believe that by offering a simple, accessible platform, we empower
        local grocery stores to extend their reach beyond physical boundaries
        while helping customers maintain their connection to the local
        businesses they trust and value. Together, we're preserving the heart of
        local commerce while making it more convenient for everyone. We will be
        extending our services to other grocery stores in the future.
      </p>
    </div>
  );
};

export default About;
